import { createAction, props } from '@ngrx/store';
import { IBusinessDetailParams, IBusinessDetailRequest } from '../models/business-detail.model';
import { ErrorResponse, IGenericError } from '../../../../../src/app/core/models/generic-models';

export const loadBusinessDetailUpdates = createAction(
  '[BusinessDetailUpdate] Load BusinessDetailUpdatesRequest',
  props<{
    request: {
      requestData: IBusinessDetailRequest;
      businessId: string;
      /** When set, POST FormData to SaveWithFile endpoint (file + formData), else PUT requestData */
      body?: FormData;
    };
  }>()
);

export const loadBusinessDetailUpdatesSuccess = createAction(
  '[BusinessDetailUpdate] Load BusinessDetailUpdates Success',
  props<{ response: any }>()
);

export const loadBusinessDetailUpdatesFailure = createAction(
  '[BusinessDetailUpdate] Load BusinessDetailUpdates Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

export const clearBusinessDetail = createAction('[Clear BusinessDetailUpdate] Clear BusinessDetailUpdates');
